/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Accordion as ChromaAccordion } from '@iag-packages/chroma-react/lib/patterns';
import styled from 'styled-components';
import THEME from 'theme';

const AccordionWrapper = styled.div`
  .p-accordion__label {
    border-bottom: 1px dotted ${THEME.FIELD.BORDER.DEFAULT};

    &.is-active {
      border-bottom: none;
    }
  }
  .p-accordion__item:first-of-type {
    border-top: 1px dotted ${THEME.FIELD.BORDER.DEFAULT};
  }
`;

export const Accordion = ({ ...props }) => (
  <AccordionWrapper>
    <ChromaAccordion {...props} />
  </AccordionWrapper>
);

export default Accordion;
